$(document).ready(function () {
    const form = document.querySelector('#new_user_info');

    form.addEventListener('submit', (event) => {
        fbq('track', 'AddToCart');
    });
});